// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-checklist2-report-widget-menu {
  margin-left: 12px;
}
.fi-checklist2-report-widget-menu .mat-mdc-icon-button.mat-mdc-button-base .mat-icon {
  font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/checklist/fi-checklist2-report/components/shared/fi-checklist2-report-widget-menu/fi-checklist2-report-widget-menu.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;AAAI;EACI,eAAA;AAER","sourcesContent":[".fi-checklist2-report-widget-menu {\r\n    margin-left: 12px;\r\n    .mat-mdc-icon-button.mat-mdc-button-base .mat-icon {\r\n        font-size: 20px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
